import { html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class SearchFilters extends OutlineElement {
  static get properties() {
    return {};
  }

  render() {
    return html`<div class="hf-search-filters">
      <slot></slot>
    </div>`;
  }
}
customElements.define('hf-search-filters', SearchFilters);
